"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenGraphTags = void 0;
const react_1 = __importDefault(require("react"));
const head_1 = __importDefault(require("next/head"));
const constants_1 = require("./constants");
/**
 *
 * @param description - The description of the website
 * @param imageUrl - The URL of the image to be used in the Open Graph card
 * @param title - The title of the website
 * @param type - The type of the website
 * @param url - The URL of the website
 * @description - The component wraps the `meta` tags inside `Head` from `next/head`.
 * Therefore it cannot be included in an other `Head` tag in the parent component.
 * here is an example of integration:
 * ```tsx
 * <Head>
 *   <meta name="a name" />
 * </Head>
 * <OpenGraphTags description="your favorite eventbrite app" />
 * <Component {...pageProps} />;
 * ```
 */
const OpenGraphTags = ({ description, imageUrl, title = "Eventbrite", type = "website", url, }) => {
    const imageTag = imageUrl ? (react_1.default.createElement("meta", { key: "og:image", property: "og:image", content: imageUrl })) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("meta", { key: "og:image:default", property: "og:image", content: constants_1.OPEN_GRAPH_DEFAULT_IMAGE_PATH }),
        react_1.default.createElement("meta", { key: "og:image:width:default", property: "og:image:width", content: constants_1.OPEN_GRAPH_DEFAULT_IMAGE_WIDTH }),
        react_1.default.createElement("meta", { key: "og:image:height:default", property: "og:image:height", content: constants_1.OPEN_GRAPH_DEFAULT_IMAGE_HEIGHT })));
    return (react_1.default.createElement(head_1.default, null,
        react_1.default.createElement("meta", { key: "og:site_name", property: "og:site_name", content: "Eventbrite" }),
        imageTag,
        react_1.default.createElement("meta", { key: "og:title", property: "og:title", content: title }),
        description && react_1.default.createElement("meta", { key: "og:description", property: "og:description", content: description }),
        react_1.default.createElement("meta", { key: "og:url", property: "og:url", content: url }),
        react_1.default.createElement("meta", { key: "og:type", property: "og:type", content: type })));
};
exports.OpenGraphTags = OpenGraphTags;
//# sourceMappingURL=OpenGraphTags.js.map